import { render } from "./employee_fonacot_modal.vue?vue&type=template&id=c5275580"
import script from "./employee_fonacot_modal.vue?vue&type=script&lang=js"
export * from "./employee_fonacot_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__